/**
 * 採用ページ「データでみる東宝ハウス新小岩」の数値カウントアップ
 * 小数（16.5 / 33.3）とカンマ区切り（1,224）を元表記のまま復元する。
 */
const SELECTOR = '.pg-recruit-data__num, .pg-recruit-data__sub-num';

// 元表記から「カンマ有無・小数桁数・目標値」を読み取る
const parseTarget = (text) => {
    const matched = text.replace(/\s/g, '').match(/-?[\d,]+(\.\d+)?/);
    if (!matched) return null;

    const raw = matched[0];
    const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
    const value = Number(raw.replace(/,/g, ''));
    if (Number.isNaN(value)) return null;

    return { value, decimals, grouped: raw.includes(',') };
};

const formatNumber = (value, decimals, grouped) => {
    const fixed = value.toFixed(decimals);
    if (!grouped) return fixed;

    const [int, dec] = fixed.split('.');
    const groupedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return dec ? `${groupedInt}.${dec}` : groupedInt;
};

const animateCount = (el, { value, decimals, grouped }, duration = 1500) => {
    const start = performance.now();

    const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        // easeOutCubic
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = formatNumber(value * eased, decimals, grouped);
        if (t < 1) {
            requestAnimationFrame(tick);
        } else {
            el.textContent = formatNumber(value, decimals, grouped);
        }
    };

    requestAnimationFrame(tick);
};

const recruitDataCount = () => {
    const targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    const entriesMap = new Map();

    targets.forEach((el) => {
        const parsed = parseTarget(el.textContent);
        if (!parsed || parsed.value <= 0) return;
        entriesMap.set(el, parsed);
        el.textContent = formatNumber(0, parsed.decimals, parsed.grouped);
    });

    if (!entriesMap.size) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const el = entry.target;
                const parsed = entriesMap.get(el);
                observer.unobserve(el);
                if (!parsed) return;
                setTimeout(() => animateCount(el, parsed), 200);
            });
        },
        { threshold: 0.6 },
    );

    entriesMap.forEach((_parsed, el) => observer.observe(el));
};

export default recruitDataCount;
